class StatisticsView{
	static init($context = null){
		var inputSelector = "[data-views-wrap]";
		let $containers = $context ? $context.find(inputSelector) : $(inputSelector);


		$containers.each(function (index, container) {
			if($(container).data('view_instance')) return;
			$(container).data('view_instance', new StatisticsView(container))
		});
	}



	constructor(wrap) {
		this.wrap = wrap
		this.$wrap = $(wrap)
		this.storageKey = "table-views-" + this.$wrap.data('views-wrap')
		this.$wrap.on('click', '[data-action]', function (e){
			let action = $(e.currentTarget).data('action');
			e.preventDefault();
			switch (action){
				case 'add':
					this.addView()
					break;
				case 'rename':
					this.renameView($(e.currentTarget).data('index'))
					break;
				case 'delete':
					this.deleteView($(e.currentTarget).data('index'))
					break;
			}

		}.bind(this))

		this.refreshViews()
		this.updateCurrentView()
	}

	deleteView(index){
		if(confirm("statistics: delete view?")){
			var views = this.getViews()
			views.splice(index, 1)
			this.setViews(views)
			this.refreshViews();
		}
	}

	renameView(index){
		var views = this.getViews()

		console.log(views, index)

		let newName = prompt("statistics: rename view", views[index].name)
		if(newName){
			views[index].name = newName;
		}

		this.setViews(views)
		this.refreshViews();
	}

	addView(){
		var views = this.getViews()
		let search = window.location.search.replace(/([&?])view_index=\d+/g, '')

		let view = {
			name: 'Skirtukas #' + (views.length + 1)
		}
		this.setViewData(view)
		views.push(view)
		this.setViews(views)


		let index = views.length - 1
		let params = view.search
		if(!params){
			params = `?view_index=${index}`
		}else{
			params += `&view_index=${index}`
		}
		window.location.href = view.pathname + params + view.hash
		this.refreshViews();
	}

	updateCurrentView(){
		let currentIndex = this.getCurrentViewIndex()
		let views = this.getViews()
		var view = views[currentIndex]
		this.setViewData(view)
		this.setViews(views)
	}

	setViewData(view){
		let search = window.location.search.replace(/([&?])view_index=\d+/g, '')
		view.pathname = window.location.pathname
		view.search = search
		view.hash = window.location.hash
	}

	getCurrentViewIndex(){
		var currentIndex = 0
		var viewIndexMatch = window.location.search.match(/view_index=(\d+)/);
		if(viewIndexMatch){
			currentIndex = viewIndexMatch[1];
		}

		return currentIndex
	}

	refreshViews(){

		var views = this.getViews()

		if(views.length === 0){
			this.addView();
			return;
		}

		this.$wrap.find('.nav-tabs > .nav-item').remove();

		if(views){

			let currentiewIndex = this.getCurrentViewIndex()

			var index = 0;
			views.forEach(function (viewData){
				let isActive = index == currentiewIndex
				var params = viewData.search

				if(!params){
					params = `?view_index=${index}`
				}else{
					params += `&view_index=${index}`
				}

				var $viewLink = $('<a class="nav-link"/>')
					.text(viewData.name || 'Vaizdas')
					.attr('href', viewData.pathname + params + viewData.hash)

				if(isActive){
					$viewLink.addClass('active')
				}
				$viewLink
					.append($('<button type="button" class="btn btn-link p-0 ms-1"><i class="fa-solid fa-pencil"></i></button>')
						.attr('data-action', 'rename')
						.attr('data-index', index)
					)
					.append($('<button type="button" class="btn btn-link p-0 ms-1"><i class="fa-regular fa-trash-can ms-1"></i></button>')
						.attr('data-action', 'delete')
						.attr('data-index', index)
					)

				var $viewWrap = $('<li class="nav-item position-relative"/>').append($viewLink)


				this.$wrap.find('.nav-tabs').append($viewWrap)
				index++;
			}.bind(this))
		}
	}

	getViews(){
		var viewsData = localStorage.getItem(this.storageKey)
		if(typeof viewsData !== 'string') [];
		var views = JSON.parse(viewsData);
		return views || [];
	}
	setViews(views){
		localStorage.setItem(this.storageKey, JSON.stringify(views));
	}
}


StatisticsView.$ = $;
if (typeof module === "object" && typeof module.exports === "object"){
	StatisticsView.init()
	//node modules support
	module.exports = StatisticsView;
}else{
	$(function(){
		StatisticsView.init()
	});
}